import moment from 'moment';

import { InjectionToken } from '@angular/core';

import { DATE_FORMAT_CONSTANTS } from '@finder/shared/constants/date.constants';

/* istanbul ignore next */
/**
 * @description Outputs the date provided (or today if no date provided) as a formatted string.
 * @param date  the date to convert
 */
export const getDateString = (date: Date = new Date(), format = DATE_FORMAT_CONSTANTS.scheduleDateFormat): string =>
    moment(date).format(format);


export type GetDateStringProvider = (date: Date, format?: string) => string;
export const GET_DATE_STRING =
    new InjectionToken('GET_DATE_STRING', {
        factory: () => getDateString
    });
